export const PageTransition = {
    state: () => ({
        animation: 'slide-left',// slide-left, slide-right
    }),
    mutations: {
        setBackState: function(state) {
            state.animation = 'slide-right';
            setTimeout(() => {
                state.animation = 'slide-left';
            }, 800);
        },
    },
    getters: {
        getAnimation: function(state) {
            return state.animation;
        },
    },
    actions: {
        setBackState: function(context) {
            context.commit('setBackState');
        },
    },
};
